import { useNewBuildAvailable, useAutoReload } from '../lib/build-version';

// App-wide bar shown when a NEWER funnel build has been deployed while this tab
// stayed open. The SPA otherwise keeps its stale bundle — the recurring "why do
// I see an older view / a different number / not the new tags" thread.
//
// The tab now auto-refreshes itself at a SAFE moment (useAutoReload): when it's
// backgrounded, or after a idle span with no field focused — so nobody is yanked
// mid-edit or mid-read. This banner is the heads-up + a "Refresh now" escape
// hatch for anyone parked on one screen who'd rather not wait for the idle timer.
export default function UpdateBanner() {
  const newBuild = useNewBuildAvailable();
  useAutoReload(newBuild);

  if (!newBuild) return null;

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <span className="update-banner__spark" aria-hidden="true">✦</span>
      <span className="update-banner__txt">
        A new version of Funnel is ready — it&rsquo;ll refresh automatically when you pause.
      </span>
      <button
        type="button"
        className="update-banner__reload"
        onClick={() => window.location.reload()}
      >
        Refresh now
      </button>
    </div>
  );
}
